module.exports = __webpack_public_path__ + "static/media/beaconManageUsersHeader.05ad49b2.jpg";